import { getExperimentVariant } from '@/global/api/queries'
import {
  MEMBER_WANNABE_NAMESPACE,
  MEMBERSHIP_NAMESPACE,
  SIMULATOR_VERSION
} from '@/global/constants/featureFlags'
import { getFeatureFlag } from '@/global/plugins/firebase'
import {
  makeExperimentKey,
  makeFeatureFlagKey
} from '@/global/utils/react-query-keys'
import { QueryClient } from '@tanstack/react-query'
import { UNIFIED_SIMULATOR_ENDPOINT_FLAG } from '@/modules/simulator/constants'

const prefetchFlags = async (queryClient: QueryClient) => {
  const experiments = {
    namespace: MEMBERSHIP_NAMESPACE,
    keys: [SIMULATOR_VERSION]
  }

  const unifiedSimulatorEndpointFlag = {
    namespace: MEMBER_WANNABE_NAMESPACE,
    key: UNIFIED_SIMULATOR_ENDPOINT_FLAG
  }

  await Promise.allSettled([
    await queryClient.prefetchQuery({
      queryKey: makeExperimentKey(experiments),
      queryFn: () => getExperimentVariant(experiments)
    }),
    await queryClient.prefetchQuery({
      queryKey: makeFeatureFlagKey(unifiedSimulatorEndpointFlag),
      queryFn: () => getFeatureFlag(unifiedSimulatorEndpointFlag)
    })
  ])
}

export { prefetchFlags }
